import React from 'react'
import TextField from '@mui/material/TextField';

const CustomInputField = ({ id, name, label, placeholder, value, onChange, error }) => {
  return (
    <div>
        <TextField
          fullWidth
          id={id}
          name={name}
          // label={label}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          error={error?.InValid}
          helperText={error?.InValid  ? `${label} is ${error?.text}.` : ''}
          sx={{
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                borderColor: error?.InValid ? "" : "#2B3252",
              },
          }}
        />
    </div>
  )
}

export default CustomInputField